import { EChartTimeseries } from "../../../components/EChartTimeseries.js";
import { useMemoizedBarSeries } from "../../../hooks/chart.js";
import { type SpecificUsageChartProps, UsageChartWrapper } from "./UsageChartWrapper.js";
import { IconStack2 } from "@tabler/icons-react";
import { TieredPriceProductId } from "@project/common";
import { checkIsApproachingLimit } from "./utils/limits.js";
import { useTilesRequestsUsage } from "./hooks/fetchUsages.js";
import { useProductNames } from "./hooks/productLabels.js";

export const TilesRequestsUsageChart = ({
  from,
  to,
  interval,
  apiKeyId,
  addToDetailedView,
}: SpecificUsageChartProps) => {
  const {
    tilesRequestsUsage,
    isLoadingTilesUsage,
    isErrorTilesUsage,
  } = useTilesRequestsUsage({ from, to, interval, apiKeyId });

  const getName = useProductNames();
  const title = getName(TieredPriceProductId.TieredTileUsage);
  const series = useMemoizedBarSeries(tilesRequestsUsage, title);

  return (
    <UsageChartWrapper
      title={title}
      iconColor="grape.3"
      icon={<IconStack2 size={20} />}
      hasError={isErrorTilesUsage}
      isLoading={isLoadingTilesUsage}
      addToDetailedView={addToDetailedView}
      hasUsage={tilesRequestsUsage.length > 0}
      isApproachingLimit={checkIsApproachingLimit(tilesRequestsUsage, TieredPriceProductId.TieredTileUsage)}
    >
      <EChartTimeseries series={series} />
    </UsageChartWrapper>
  );
};
